/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type BadgeInfoDTO = {
    id: number;
    name: string;
    description: string;
    iconUrl: string;
    type: BadgeInfoDTO.type;
};
export namespace BadgeInfoDTO {
    export enum type {
        NORMAL = 'NORMAL',
        SPECIAL = 'SPECIAL',
    }
}

